var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 2C10.4419 2 10.8001 2.35817 10.8001 2.8V13.2C10.8001 13.6418 10.4419 14 10.0001 14C9.55827 14 9.2001 13.6418 9.2001 13.2V2.8C9.2001 2.35817 9.55827 2 10.0001 2Z",
    fill: "#3CAE8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.23441 9.43431C6.54683 9.1219 7.05336 9.1219 7.36578 9.43431L10.0001 12.0686L12.6344 9.43431C12.9468 9.1219 13.4534 9.1219 13.7658 9.43431C14.0782 9.74673 14.0782 10.2533 13.7658 10.5657L10.5658 13.7657C10.2534 14.0781 9.74683 14.0781 9.43441 13.7657L6.23441 10.5657C5.92199 10.2533 5.92199 9.74673 6.23441 9.43431Z",
    fill: "#3CAE8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4001 14C4.84193 14 5.2001 14.3582 5.2001 14.8V16.4H14.8001V14.8C14.8001 14.3582 15.1583 14 15.6001 14C16.0419 14 16.4001 14.3582 16.4001 14.8V16.4C16.4001 17.2837 15.6838 18 14.8001 18H5.2001C4.31644 18 3.6001 17.2837 3.6001 16.4V14.8C3.6001 14.3582 3.95827 14 4.4001 14Z",
    fill: "#3CAE8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.fec18a98c149b495d2e9f42e301d79db.svg";
export { ForwardRef as ReactComponent };